import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NewsSVG } from '@common_components/svg/news.svg';

const NewsIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <NewsSVG/>
    </div>
  );
};

export { NewsIcon };
